'use client';

import DownloadElem from '@/components/support/product_support/DownloadElem';
import { Downloadable } from '@/types/product_page/productType';

const DownloadList = ({ data }: { data: Downloadable[] }) => {
  return (
    <section id="downloads" className="w-full py-6 md:py-10 px-4 md:px-6">
      <h1 className={`text-3xl font-bold text-center mb-6 md:mb-12`}>
        Downloads
      </h1>
      <div className="max-w-7xl w-full mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {data?.map((item, index) => (
          <DownloadElem
            key={index}
            name={item.directus_files_id.title}
            file={item.directus_files_id.id}
            size={item.directus_files_id.filesize}
            fileType={item.directus_files_id.type}
          />
        ))}
      </div>
    </section>
  );
};

export default DownloadList;
